module.exports = __webpack_public_path__ + "img/support_prot_4.29041678.png";